import { Stack, Typography } from '@mui/material';
import React from 'react';
import colors from '../../values/colors';
import strings from '../../values/strings/strings';
import logoLight from '../../assets/images/logo_light.png';
import logoDark from '../../assets/images/logo_dark.png';

function SaframaxLogo(props) {
    return (
        <div style={{justifyContent: 'center', display: 'flex', padding: 20}}>
            <Stack style={{alignItems: 'center',}}>
                <img style={{width: props.width ? props.width : 250, margin: 10}} src={colors.getTheme().palette.mode === 'light' ? logoLight : logoDark} />
                <Typography variant="h4" align="center">{strings.getString('app_name').toUpperCase()}</Typography>
            </Stack>
        </div>
    );
}

export default SaframaxLogo;